/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const archiveCustomerBodyExpectedCustomerVersionExclusiveMin = 0;
export const archiveCustomerBodyExpectedCustomerVersionMax = 9007199254740991;

export const ArchiveCustomerBody = zod.object({
  expectedCustomerVersion: zod
    .int()
    .gt(archiveCustomerBodyExpectedCustomerVersionExclusiveMin)
    .max(archiveCustomerBodyExpectedCustomerVersionMax),
  confirmed: zod.literal(true),
});

export type ArchiveCustomerBody = zod.input<typeof ArchiveCustomerBody>;
export type ArchiveCustomerBodyOutput = zod.output<typeof ArchiveCustomerBody>;
